var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile---DONE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "159-Edit-Profile-Picture-Popup...",
    transform: "translate(-214, -429)",
    fill: "#5C88FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20, 350)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(21, 64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(88, 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(69, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(7, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9, 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52974675,13.4049257 C8.99488206,13.3966955 8.47920258,13.2047055 8.06953914,12.8612615 L5.37190922,10.4889385 C4.9474187,10.092897 4.29829543,10.0615372 3.83747143,10.4148197 L0.00142434017,13.2319029 L0.00142434017,15.0605616 C-0.0261455163,15.5511082 0.349837217,15.9710834 0.841120691,15.9986119 C0.866416744,16 0.89180754,16.0003619 0.917150965,15.9996051 L14.5042584,15.9996051 C15.0487394,15.9996051 15.5932203,15.6042259 15.5932203,15.0605616 L15.5932203,10.2665347 L10.7176665,13.0836653 C10.3592584,13.2987849 9.94793694,13.4100341 9.52974675,13.4049257 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.3559322,
    cy: 7.45762712,
    r: 1.08474576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2131043,1.93338445 C18.0550362,1.71824275 17.8108483,1.58273756 17.5445261,1.5623313 L4.04902071,0.00397433805 C3.78592151,-0.0180417033 3.52334367,0.0518888195 3.30617189,0.201881979 C3.113836,0.36873043 2.98306845,0.595187905 2.93472379,0.845034465 L2.71186441,2.77444458 L14.548295,2.77444458 C15.6767635,2.80001159 16.5892452,3.7006334 16.6283475,4.82752329 L16.6283475,13.559322 C16.6283475,13.5098451 16.8512069,13.4603682 16.950266,13.3614144 C17.1553042,13.2005789 17.2741752,12.9539519 17.2721846,12.6935471 L18.4359636,2.65072863 C18.4617001,2.39131811 18.3813152,2.13257044 18.2131043,1.93338445 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.504203,3.79661017 L0.915813061,3.79661017 C0.371280687,3.79661017 0,4.31637844 0,4.86092465 L0,11.9152001 L3.26714687,9.5390286 C4.0964999,8.92379655 5.24383634,8.97548438 6.01453867,9.66277618 L8.73715317,12.0389477 C9.14770803,12.3874971 9.73412022,12.4371951 10.1974512,12.1626953 L15.5932203,9.01921295 L15.5932203,4.86092465 C15.5557938,4.27985111 15.0859724,3.82072484 14.504203,3.79661017 Z M9.33119279,9.51425066 C8.18295622,9.51425066 7.2520778,8.58339595 7.2520778,7.43508282 C7.2520778,6.28681707 8.18290884,5.35591498 9.33119279,5.35591498 C10.4794294,5.35591498 11.4103078,6.28676969 11.4103078,7.43508282 C11.4103078,8.58339595 10.4794767,9.51425066 9.33119279,9.51425066 Z",
    id: "Shape"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGallery);
export default __webpack_public_path__ + "static/media/ic_gallery.a6f839c8ffd4a5e80bb46c657afa05db.svg";
export { ForwardRef as ReactComponent };